import { ReactNode } from "react";
import "./Answer.module.css";
// import { RelatedCaseletProps } from "../chat/RenderFollowupCaselet";


type HtmlParsedAnswer = {
  answerHtml: string | JSX.Element[];
  citations: string[];
  followupQuestions: string[];
  // relatedCaselets: RelatedCaseletProps[];
};


// const citationWithLink: CitationItem[] = [...];
interface KeywordHighlightProps {
  text: string;
  keywords: string[];
}

function highlightKeywords({
  text,
  keywords,
}: KeywordHighlightProps): ReactNode[] {
  return text
    .split(" ")
    .map((word, idx) => {
      if (keywords.includes(word)) {
        return <strong key={idx}>{word}</strong>;
      } else {
        return word;
      }
    })
    .reduce((prev: ReactNode[], curr, idx) => {
      if (idx > 0) {
        prev.push(" ");
      }
      prev.push(curr);
      return prev;
    }, []);
}

export function parseAnswerToHtml(
  answer: string,
  followupQuestions: string[],
  // relatedCaselets: RelatedCaseletProps[],
  // onCitationClicked: (citationFilePath: string) => void,
  citationWithLink?: any
): HtmlParsedAnswer {
  const citations: string[] = [];

  let parsedAnswer = answer.trim();

  let formattedText: string = parsedAnswer
    .split("\n")
    .map((line: any) => line + "\n")
    .join("");
  let lastIndex = formattedText.length;
  for (let i = formattedText.length - 1; i >= 0; i--) {
    if (formattedText[i] === "]") {
      break;
    } else if (formattedText[i] === "[") {
      lastIndex = i;
      break;
    }
  }

  const truncatedAnswer = formattedText.substring(0, lastIndex);
  formattedText = truncatedAnswer;
  const paragraphs = formattedText.split(/\n/g);
  const fragments:string[] = paragraphs.map((paragraph) => {
    const parts = paragraph.split(/\[([^\]]+)\]/g);
    let citationIndex: number;
    const paragraphFragments = parts.map((part, partIndex) => {
      if (partIndex % 2 === 0) {
        if (part.trim() === "") {
          return;
        }
        return (
            part
        );
      } 
     
    });
    return paragraphFragments.join('')
  });
  return {
    answerHtml: fragments.join('\n'),
    citations,
    followupQuestions,
    // relatedCaselets,
  };
}
